import React, { useEffect, useState } from 'react';
import { FaEdit, FaHistory } from 'react-icons/fa';
import { toast } from 'react-toastify';
import moment from 'moment';
import api from '../services/api';
import ModalButton from './ModalButton';
import { FinField, FinInput } from './FinField';

export const getNomeOperadorHistorico = (row) => {
    const operadorId = String(row?.operador?.id ?? row?.operador ?? '');
    const participanteId = String(row?.participante?.id ?? row?.participante ?? '');
    const perfilOperador = String(row?.operador?.cargo?.perfil?.codigo ?? '').trim().toLowerCase();

    if (operadorId === '') return "";

    // Ação feita pelo próprio participante: operador ID = participante ID
    if (operadorId === participanteId) {
        return row?.operador?.nome ?? "";
    }

    // Ação feita por operador: exibe nome só se tiver perfil configurado
    if (perfilOperador === '') return "";

    return row?.operador?.nome ?? "";
};

// Rótulo de cada chave devolvida pelo endpoint proximoStep (ParticipanteController::proximoStepPendente).
// `recusado` e `concluido` ficam de fora de propósito: não são etapa pendente, e nesses casos o badge
// mostra a situação do participante, que descreve melhor o que aconteceu.
const LABEL_ETAPA = {
    cartaInformativa: 'Carta Informativa',
    carta: 'Assinatura de Carta',
    termo: 'Aceite do Termo',
    dados: 'Confirmação de Dados',
    aereo: 'Aéreo',
    transfer: 'Transfer',
    hotel: 'Hotel',
};

/**
 * `carregando` cobre SO esta tabela, com backdrop e spinner proprios.
 *
 * De proposito nao usa o `processando` do ErpTemplate: quando a carta sai da fila o
 * historico se atualiza sozinho, e a tela do cadastro segue editavel — um overlay de
 * pagina inteira travaria o formulario que o operador esta preenchendo por causa de
 * uma tabela no rodape.
 */
export default function TabelaHistoricoParticipante({ historico, setHistorico, token, idParticipante, situacao, carregando = false }) {
    const [proximoStep, setProximoStep] = useState(null);

    // O back é a fonte única da próxima etapa (mesmo endpoint que o fluxo do convidado usa para rotear),
    // então o badge não reimplementa a ordem das etapas aqui.
    useEffect(() => {
        if (!idParticipante || !token) {
            return;
        }
        api({
            method: 'get',
            action: '/participante/' + idParticipante + '/proximoStep',
            token: token,
        })
            .then((response) => setProximoStep(response.data?.proximoStep ?? null))
            .catch(() => setProximoStep(null));
    }, [idParticipante, token]);

    const etapaPendente = LABEL_ETAPA[proximoStep];
    const corSituacao = situacao?.cor ?? '#586478';

    return (
        <>
            <div className="fin-pp__cphead" style={{ marginTop: 16 }}>
                <span className="fin-pp__cphead-ic"><FaHistory size={15} /></span>
                <span className="fin-pp__cphead-title">Histórico</span>
                {etapaPendente
                    ? <span className="fin-pp__cphead-pill is-warn">Pendente: {etapaPendente}</span>
                    : (situacao?.nome
                        ? <span
                            className="fin-pp__tag"
                            style={{ marginLeft: 'auto', backgroundColor: corSituacao + '1f', color: corSituacao, borderColor: corSituacao + '55' }}
                        >
                            {situacao.nome}
                        </span>
                        : null)
                }
            </div>
        <div className="fin-pp__card" style={{ overflow: 'hidden', position: 'relative' }}>
            {carregando ? (
                <div
                    style={{
                        position: 'absolute',
                        inset: 0,
                        zIndex: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: 'rgba(255, 255, 255, .72)',
                    }}>
                    <span className="fin-pp__spinner" />
                </div>
            ) : null}
            <div className="fin-pp__tblwrap">
                <table className="fin-pp__tbl">
                    <thead>
                        <tr>
                            <th style={{ width: 200 }}>Operador</th>
                            <th style={{ width: 140 }}>Data</th>
                            <th style={{ width: 200 }}>Status</th>
                            <th>Observação</th>
                            <th style={{ width: 80 }}>Alterar</th>
                        </tr>
                    </thead>
                    <tbody>
                        {historico.length === 0
                            ? <tr><td colSpan={5} className="fin-pp__empty">Nenhum registro</td></tr>
                            : historico.map((row, index) => (
                                <tr key={index}>
                                    <td className="fin-pp__cell-muted">{getNomeOperadorHistorico(row)}</td>
                                    <td className="fin-pp__cell-muted">{row.created_at ? moment(row.created_at).format("DD/MM/YYYY HH:mm") : ""}</td>
                                    <td>{row.situacao?.nome ?? ""}</td>
                                    <td>{row.historico ?? ""}</td>
                                    <td>
                                        <ModalButton
                                            title="Alterar"
                                            icon={<FaEdit size={16} />}
                                            color="primary"
                                            onHide={() => {
                                                api({
                                                    method: 'put',
                                                    action: '/participanteHistoricoSituacao/' + row.id,
                                                    token: token,
                                                    data: {
                                                        historico: row.historico,
                                                    }
                                                })
                                                    .then(function (response) {
                                                        toast.success('Dados registrados com sucesso');
                                                    })
                                                    .catch(function (error) {
                                                        toast.error('Erro: ' + (error.response?.data?.error ?? " ao carregar dados"));
                                                    });
                                            }}
                                        >
                                            <div className="fin-pp__filters">
                                                <FinField label="Observação" full>
                                                    <FinInput
                                                        id="historico"
                                                        value={row.historico ?? ''}
                                                        onChange={(e) => {
                                                            historico[index].historico = e.target.value;
                                                            setHistorico([...historico]);
                                                        }}
                                                        style={{ paddingLeft: 14 }}
                                                    />
                                                </FinField>
                                            </div>
                                        </ModalButton>
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>
        </div>
        </>
    );
}
